// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__vmq-h","header":"MessagesList_header__1YSYX","chat":"MessagesList_chat__GSR5R"};